<template>
    <div class="embed-responsive embed-responsive-16by9 youtube-video">
        <youtube
            ref="player"
            :video-id="videoId"
            class="embed-responsive-item"
        ></youtube>
    </div>
</template>

<script>
export default {
    name: "YoutubeVideo",
    props: {
        videoId: {
            type: String,
            required: true
        },
    },
    data: () => ({
        isPlaying: false,
    }),
}
</script>

<style scoped>

</style>
